import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import React from "react";

function TaskSchedulerDetails({
  name,
  taskTitle,
  description,
  taskPriorityId,
  assignToId,
  priorities,
  assignees,
  onNameChange,
  onTaskTitleChange,
  onDescriptionChange,
  onTaskPriorityChange,
  onAssignToChange,
}) {
  return (
    <Box sx={{ "& .MuiTextField-root": { m: 1, width: "95%" } }}>
      <TextField
        autoFocus
        required
        margin="dense"
        name="name"
        label="Name"
        type="text"
        variant="outlined"
        value={name}
        onChange={onNameChange}
      />
      <TextField
        required
        margin="dense"
        name="title"
        label="Task Title"
        type="text"
        variant="outlined"
        value={taskTitle}
        onChange={onTaskTitleChange}
      />
      <TextField
        id="task-scheduler-description"
        name="description"
        label="Description"
        placeholder="Description"
        fullWidth
        multiline
        rows={4}
        cols={10}
        value={description}
        onChange={onDescriptionChange}
        size="small"
      />
      <FormControl
        variant="outlined"
        sx={{ m: 1, minWidth: "47%" }}
        size="small"
      >
        <InputLabel size="small" id="task-scheduler-priority-label">
          Task Priority
        </InputLabel>
        <Select
          labelId="task-scheduler-priority-label"
          id="task-scheduler-priority"
          value={taskPriorityId}
          onChange={onTaskPriorityChange}
          label="Task Priority"
          size="small"
        >
          <MenuItem value="0">
            <em>Select Task Priority</em>
          </MenuItem>
          {priorities?.map((prt) => (
            <MenuItem key={prt.id} value={prt.id}>
              {prt.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
        variant="outlined"
        sx={{ m: 1, minWidth: "46%" }}
        size="small"
      >
        <InputLabel size="small" id="task-scheduler-assign-label">
          Assign To
        </InputLabel>
        <Select
          labelId="task-scheduler-assign-label"
          id="task-scheduler-assign"
          value={assignToId}
          onChange={onAssignToChange}
          label="Assign To"
          size="small"
        >
          <MenuItem value="0">
            <em>Select Assignee</em>
          </MenuItem>
          {assignees?.map((assignee) => (
            <MenuItem key={assignee.id} value={assignee.id}>
              {assignee.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default TaskSchedulerDetails;
